export default "__VITE_ASSET__DVUIOknz__"